<template>
  <div v-if="!item.hidden" class="menu-wrapper">

    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item
            :meta="Object.assign({},item.meta,onlyOneChild.meta,{ dot: ($store.getters.notesStatus !== 0) },
                                 { fileDot: ($store.getters.newFileStatus !== 0 && dashboardAction.IsPermit) },
                                 { noAppeal: ($store.getters.newAppealStatus !== 0 || $store.getters.newUnAppealStatus !== 0) },
                                 { noAgency: ($store.getters.newAgencyStatus !== 0 || $store.getters.newUnAgencyStatus !== 0) },
                                 { noPurchase: ($store.getters.newPurchaseStatus !== 0) },
                                 { noSale: ($store.getters.newSaleStatus !== 0) },
                                 { noReimbursement: ($store.getters.newReimbursementStatus !== 0 && reimbursementAction) },
                                 { noCashRequirement: ($store.getters.newCashRequirementStatus !== 0 && cashRequirementAction) },
                                 { customer: (getStatus(33)) },
                                 { contract: (getStatus(41)) })" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item
          :meta="item.meta"
          :appeal = "($store.getters.newAppealStatus !== 0 || $store.getters.newUnAppealStatus !== 0) && appealAction.IsPermit"
          :agency = "($store.getters.newAgencyStatus !== 0 || $store.getters.newUnAgencyStatus !== 0) && agencyAction.IsPermit"
          :purchase = "$store.getters.newPurchaseStatus !== 0 && purchaseAction.IsPermit"
          :sale = "$store.getters.newSaleStatus !== 0 && saleAction.IsPermit"
          :approval = "($store.getters.newReimbursementStatus !== 0 && reimbursementAction) || $store.getters.newCashRequirementStatus !== 0 && cashRequirementAction"
          :trade-payment = "getStatus(33)||getStatus(41)"/>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :is-nest="true"
        :item="child"
        :key="child.path"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
        style="background-color: #36a3f7" />
    </el-submenu>

  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import { getAction } from '@/utils'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    dot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  computed: {
    actions() {
      return this.$store.getters.actions
    },
    dashboardAction() {
      return getAction(this.actions, 13)
    },
    appealAction() {
      return getAction(this.actions, 1111111)
    },
    agencyAction() {
      return getAction(this.actions, 1111112)
    },
    purchaseAction() {
      return getAction(this.actions, 1111121)
    },
    saleAction() {
      return getAction(this.actions, 1111122)
    },
    reimbursementAction() {
      return getAction(this.actions, 111113113).IsPermit || getAction(this.actions, 111113114).IsPermit || getAction(this.actions, 111113115).IsPermit
    },
    cashRequirementAction() {
      return getAction(this.actions, 111113122).IsPermit || getAction(this.actions, 111113123).IsPermit ||
             getAction(this.actions, 111113124).IsPermit || getAction(this.actions, 111113125).IsPermit || getAction(this.actions, 111113126).IsPermit
    }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    getStatus(type) {
      const temp = this.$store.getters.accountingRedDot.filter(v => {
        return v.Type === type
      })
      return temp && temp.length > 0 ? temp[0].Status === 1 : false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue